"use client";

import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  Divider,
  IconButton,
  Chip,
} from "@mui/material";
import {
  Close as CloseIcon,
  Save as SaveIcon,
  Upload as UploadIcon,
  AddPhotoAlternate as AddPhotoAlternateIcon,
} from "@mui/icons-material";
import moment from "moment";
import { postData, putData } from "../../../../../services/library";
import { usePlanta } from "../../../context/PlantaContext";
import { ENDPOINTS } from "../../../config/endpoints";
import AuditoriaPanel from "../../auditoria-panel";

export function CorrectiveMaintenanceEditForm({
  open,
  onClose,
  rowData,
  refetch,
  showToast
}) {
  const {plantaSeleccionada } = usePlanta();
  const [formData, setFormData] = useState({
    id_planta: plantaSeleccionada,
    id_equipo: rowData.id_equipo,
    titulo: rowData.titulo,
    tarea: rowData.tarea,
    materiales: rowData.materiales,
    vencimiento: rowData.vencimiento,
    ejecuto: rowData.ejecuto,
    realizado: rowData.realizado,
    costo_materiales: rowData.costo_materiales,
    otros_costos: rowData.otros_costos,
    observaciones: rowData.observaciones,
    observacionesOT: rowData.observacionesOT,
    preparo: localStorage.getItem("user"),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const onPutCorrectivo = async (e) => {
    try {
      await putData(e, `${ENDPOINTS.CORRECTIVOS.BASE}/${rowData.id_correctivo}`, formData, () => {});
      showToast("Mantenimiento actualizado correctamente", "success");
      await refetch();
      onClose();
    } catch (error) {
      console.error(error);
      showToast("Error al actualizar mantenimiento", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            Editar Mantenimiento Correctivo
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <form action="PUT" onSubmit={onPutCorrectivo}>
      <DialogContent dividers>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                bgcolor: "background.paper",
                borderRadius: 1,
                border: "1px solid",
                borderColor: "divider",
              }}
            >
              <Typography
                variant="subtitle2"
                color="text.secondary"
                gutterBottom
              >
                Equipo Afectado
              </Typography>
              <Typography variant="h6">
                {rowData?.equipo} ({rowData?.id_equipo})
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Sección: {rowData?.sector}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1" gutterBottom>
              Información de la Falla
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Título"
              name="titulo"
              value={formData.titulo}
              onChange={handleChange}
              placeholder="Ej: Falla en sistema de refrigeración"

              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Tarea"
              name="tarea"
              value={formData.tarea}
              onChange={handleChange}
              placeholder="Ej: Falla en sistema de refrigeración"
              
              required
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12}>
              <TextField
                id=""
                fullWidth
                multiline
                rows={3}
                
                placeholder="Materiales"
                label="Materiales"
                name="materiales"
                value={formData.materiales}
                onChange={handleChange}
              />
            </Grid>
      
     <Grid item xs={4}>
                  <TextField
                    id=""
                    focused
                    required
                    fullWidth
                    type="date"
                    label="Vencimiento del Mantenimiento"
                    name="vencimiento"
                    inputProps={{
                      min: moment(new Date()).format("YYYY-MM-DD"),
                    }}
                    value={formData.vencimiento}
                    onChange={handleChange}
                  />
                </Grid>
        </Grid>
        <AuditoriaPanel tabla="mp_correctivos" idRegistro={rowData.id_correctivo} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          type="submit"
          variant="contained"
          startIcon={<SaveIcon />}
          color="primary"
        >
          Guardar Mantenimiento
        </Button>
      </DialogActions>
      </form>
    </Dialog>
  );
}
